module.exports = __webpack_public_path__ + "img/797367_302E29_ABA3A0_443C35-256px.cfc4e944.png";